<template>
  <div>
    <div v-if="todasMetas.length" class="d-flex justify-end mb-2">
      <v-btn text x-small color="primary" @click="toggleTodos">
        <v-icon left x-small>{{ algumFechado ? "mdi-unfold-more-horizontal" : "mdi-unfold-less-horizontal" }}</v-icon>
        {{ algumFechado ? "Expandir todas" : "Recolher todas" }}
      </v-btn>
    </div>
    <div style="display: flex; flex-direction: column; gap: 16px">
    <div
      v-for="meta in todasMetas"
      :key="meta.id_campanha_meta"
      class="meta-card"
      style="border: 1px solid rgba(0,0,0,0.32); border-radius: 6px; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.07)"
    >
      <!-- header (clicável: recolhe/expande) -->
      <div class="px-4 pt-3 pb-2" style="background: linear-gradient(to right, #0c2646, #2a5788); cursor: pointer" @click="toggle(meta.id_campanha_meta)">
        <div class="d-flex align-center justify-space-between mb-1">
          <span class="headline font-weight-bold white--text d-flex align-center">
            <v-icon small color="white" class="mr-1" style="transition: transform 0.2s" :style="{ transform: isAberto(meta.id_campanha_meta) ? 'rotate(0deg)' : 'rotate(-90deg)' }">mdi-chevron-down</v-icon>
            {{ meta.tipo_conteudo }}
            <template v-if="meta.id_tipo_conteudo == 1 && labelIndicadores(meta.id_campanha_meta)">
              <span class="body-1 font-weight-regular" style="color: rgba(255,255,255,0.7)">({{ labelIndicadores(meta.id_campanha_meta) }})</span>
            </template>
          </span>
          <div v-if="onEdite" class="d-flex align-center flex-shrink-0 ml-2" style="gap: 4px">
            <v-btn x-small color="white" outlined @click.stop="$emit('editar-meta', meta)">Editar</v-btn>
            <v-btn x-small color="error" outlined @click.stop="$emit('excluir-meta', meta)">Excluir</v-btn>
          </div>
        </div>
        <div class="d-flex align-center flex-wrap" style="gap: 2px 8px">
          <span class="caption font-weight-bold" style="color: rgba(255,255,255,0.9)">#{{ meta.id_campanha_meta }}</span>
          <span class="caption" style="color: rgba(255,255,255,0.5)">·</span>
          <span class="caption" style="color: rgba(255,255,255,0.9)"><span style="color: rgba(255,255,255,0.6)">Realizado: </span><span class="font-weight-medium">{{ labelRealizado(meta) }}</span></span>
          <template v-if="meta.id_tipo_conteudo != 2">
            <span class="caption" style="color: rgba(255,255,255,0.5)">·</span>
            <span class="caption" style="color: rgba(255,255,255,0.9)"><span style="color: rgba(255,255,255,0.6)">Cálculo: </span><span class="font-weight-medium">{{ labelCalculo(meta) }}</span></span>
          </template>
          <span class="caption" style="color: rgba(255,255,255,0.5)">·</span>
          <span class="caption" style="color: rgba(255,255,255,0.9)"><span style="color: rgba(255,255,255,0.6)">Pagamento: </span><span class="font-weight-medium">{{ labelPagamento(meta) }}</span></span>
          <span class="caption" style="color: rgba(255,255,255,0.5)">·</span>
          <span class="caption" style="color: rgba(255,255,255,0.9)"><span style="color: rgba(255,255,255,0.6)">Participantes: </span><span class="font-weight-medium">{{ metaInfo(meta.id_campanha_meta).colaboradores.length }}</span></span>
          <!-- A camada do participante e uma segunda meta, independente da meta
               por item, e muda quanto a campanha paga — sem isto ela so aparecia
               abrindo a meta para editar. Só nos objetivos que podem ter a
               camada (Modelo), como o "Cálculo" acima já se omite no Chassi:
               "Não" num objetivo onde ela nem existe seria ruído. -->
          <template v-if="meta.id_tipo_conteudo == 3 || temMetaParticipante(meta)">
            <span class="caption" style="color: rgba(255,255,255,0.5)">·</span>
            <span class="caption" style="color: rgba(255,255,255,0.9)"><span style="color: rgba(255,255,255,0.6)">Meta do participante: </span><span class="font-weight-medium">{{ temMetaParticipante(meta) ? "Sim" : "Não" }}</span></span>
          </template>
          <span class="caption" style="color: rgba(255,255,255,0.5)">·</span>
          <span class="caption" style="color: rgba(255,255,255,0.9)"><span style="color: rgba(255,255,255,0.6)">Total est.: </span><span class="font-weight-medium">{{ formatarMoeda(totalEstimadoMeta(meta)) }}</span></span>
        </div>
      </div>
      <!-- corpo recolhível -->
      <template v-if="isAberto(meta.id_campanha_meta)">

      <!-- participantes com valores -->
      <div style="border-top: 1px solid rgba(0,0,0,0.28)">
        <div style="padding: 8px 12px; background: #f5f5f5; display: flex; justify-content: space-between; align-items: center">
          <p class="caption font-weight-bold text-uppercase grey--text text--darken-2 ma-0" style="letter-spacing: 0.06em">
            Participantes <span style="color: #1976d2">({{ metaInfo(meta.id_campanha_meta).colaboradores.length }})</span>
          </p>
          <PaginadorSecao
            rotulo="Participantes"
            :pagina="paginaDe('part', meta.id_campanha_meta)"
            :total-paginas="totalPaginas(metaInfo(meta.id_campanha_meta).colaboradores.length)"
            @mudar="d => mudarPagina('part', meta.id_campanha_meta, d, metaInfo(meta.id_campanha_meta).colaboradores.length)"
          />
        </div>
        <div
          style="padding: 6px 12px; background: #eeeeee; border-top: 1px solid rgba(0,0,0,0.22)"
          :style="gridColaboradores(meta)"
        >
          <p class="caption font-weight-medium grey--text text--darken-2 ma-0">Nome</p>
          <p class="caption font-weight-medium grey--text text--darken-2 ma-0">Função</p>
          <p class="caption font-weight-medium grey--text text--darken-2 ma-0">Empresa</p>
          <template v-if="meta.id_tipo_calculo != 2">
            <p v-if="meta.id_tipo_conteudo != 2" class="caption font-weight-medium grey--text text--darken-2 ma-0">Meta</p>
            <p class="caption font-weight-medium grey--text text--darken-2 ma-0">{{ labelBonus(meta) }}</p>
            <p v-if="meta.id_tipo_conteudo == 1" class="caption font-weight-medium grey--text text--darken-2 ma-0">Bônus Estimado</p>
          </template>
          <template v-else>
            <p class="caption font-weight-medium grey--text text--darken-2 ma-0">Faixas</p>
          </template>
        </div>
        <div style="border-top: 1px solid rgba(0,0,0,0.22)">
          <div
            v-for="col in fatiar(metaInfo(meta.id_campanha_meta).colaboradores, 'part', meta.id_campanha_meta)"
            :key="col.nome + col.nome_empresa"
            :style="gridColaboradores(meta)"
            style="align-items: center; padding: 8px 12px; border-bottom: 1px solid rgba(0,0,0,0.18)"
          >
            <div>
              <span class="caption font-weight-medium d-block">{{ col.nome }}</span>
              <span class="caption grey--text text--darken-1" style="font-size: 11px">{{ col.nome_empresa || "—" }}</span>
            </div>
            <span class="caption grey--text text--darken-1">{{ col.funcao || "—" }}</span>
            <span class="caption grey--text text--darken-1">{{ col.nome_empresa || "—" }}</span>
            <template v-if="meta.id_tipo_calculo != 2">
              <span v-if="meta.id_tipo_conteudo != 2" class="caption">{{ getColabMeta(meta.id_campanha_meta, col.nome, meta) }}</span>
              <span class="caption font-weight-bold" style="color: #1976d2">{{ getColabBonus(meta.id_campanha_meta, col.nome, meta) }}</span>
              <span v-if="meta.id_tipo_conteudo == 1" class="caption font-weight-bold" style="color: #4caf50">{{ getColabBonusEstimado(meta.id_campanha_meta, col.nome, meta) }}</span>
            </template>
            <template v-else>
              <span class="caption grey--text">ver faixas abaixo</span>
            </template>
          </div>
        </div>
      </div>

      <!-- conteúdo: faixas de indicadores (só exibe faixas) -->
      <template v-if="meta.id_tipo_conteudo == 1 && meta.id_tipo_calculo == 2">
        <div style="border-top: 1px solid rgba(0,0,0,0.28)">
          <div style="padding: 8px 12px; background: #f5f5f5">
            <p class="caption font-weight-bold text-uppercase grey--text text--darken-2 ma-0" style="letter-spacing: 0.06em">
              Faixas <span style="color: #1976d2">({{ metaInfo(meta.id_campanha_meta).faixasIndicador.length }})</span>
            </p>
          </div>
          <div style="display: grid; grid-template-columns: 70px 1fr 90px 90px 130px; padding: 6px 12px; background: #eeeeee; border-top: 1px solid rgba(0,0,0,0.22)">
            <p class="caption font-weight-medium grey--text text--darken-2 ma-0">ID</p>
            <p class="caption font-weight-medium grey--text text--darken-2 ma-0">Indicador</p>
            <p class="caption font-weight-medium grey--text text--darken-2 ma-0">De</p>
            <p class="caption font-weight-medium grey--text text--darken-2 ma-0">Até</p>
            <p class="caption font-weight-medium grey--text text--darken-2 ma-0">{{ labelBonus(meta) }}</p>
          </div>
          <div style="border-top: 1px solid rgba(0,0,0,0.22)">
            <div
              v-for="faixa in metaInfo(meta.id_campanha_meta).faixasIndicador"
              :key="faixa._key"
              style="display: grid; grid-template-columns: 70px 1fr 90px 90px 130px; align-items: center; padding: 8px 12px; border-bottom: 1px solid rgba(0,0,0,0.18)"
            >
              <span class="caption font-weight-medium">{{ faixa.id_indicador }}</span>
              <span class="caption grey--text text--darken-1">{{ faixa.indicador || "—" }}</span>
              <span class="caption">{{ faixa.qtde_de }}</span>
              <span class="caption">{{ faixa.qtde_ate }}</span>
              <span class="caption font-weight-bold" style="color: #1976d2">{{ formatarMoeda(faixa.valor_bonus) }}</span>
            </div>
          </div>
        </div>
      </template>

      <!-- conteúdo: chassi (nomes dos chassi) -->
      <template v-else-if="meta.id_tipo_conteudo == 2">
        <div style="border-top: 1px solid rgba(0,0,0,0.28)">
          <div style="padding: 8px 12px; background: #f5f5f5">
            <p class="caption font-weight-bold text-uppercase grey--text text--darken-2 ma-0" style="letter-spacing: 0.06em">
              Chassi <span style="color: #1976d2">({{ metaInfo(meta.id_campanha_meta).chassi.length }})</span>
            </p>
          </div>
          <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 6px 12px; background: #eeeeee; border-top: 1px solid rgba(0,0,0,0.22)">
            <p class="caption font-weight-medium grey--text text--darken-2 ma-0">Chassi</p>
            <p class="caption font-weight-medium grey--text text--darken-2 ma-0">Resumido</p>
          </div>
          <div style="border-top: 1px solid rgba(0,0,0,0.22)">
            <div
              v-for="c in metaInfo(meta.id_campanha_meta).chassi"
              :key="c.chassi_completo"
              style="display: grid; grid-template-columns: 1fr 1fr; align-items: center; padding: 8px 12px; border-bottom: 1px solid rgba(0,0,0,0.18)"
            >
              <span class="caption" style="font-family: monospace">{{ c.chassi_completo }}</span>
              <span class="caption grey--text text--darken-1">{{ c.chassi_resumido || "—" }}</span>
            </div>
          </div>
        </div>
      </template>

      <!-- conteúdo: modelos (faixas ou nomes) -->
      <template v-else-if="meta.id_tipo_conteudo == 3">
        <div style="border-top: 1px solid rgba(0,0,0,0.28)">
          <div style="padding: 8px 12px; background: #f5f5f5; display: flex; justify-content: space-between; align-items: center">
            <p class="caption font-weight-bold text-uppercase grey--text text--darken-2 ma-0" style="letter-spacing: 0.06em">
              Modelos
              <span style="color: #1976d2">({{ meta.id_tipo_calculo == 2 ? metaInfo(meta.id_campanha_meta).faixasModelo.length : metaInfo(meta.id_campanha_meta).modelos.length }})</span>
            </p>
            <PaginadorSecao
              rotulo="Modelos"
              :pagina="paginaDe('modelo', meta.id_campanha_meta)"
              :total-paginas="totalPaginas(listaModelos(meta).length)"
              @mudar="d => mudarPagina('modelo', meta.id_campanha_meta, d, listaModelos(meta).length)"
            />
          </div>
          <template v-if="meta.id_tipo_calculo == 2">
            <div style="display: grid; grid-template-columns: 70px 1fr 90px 90px 130px; padding: 6px 12px; background: #eeeeee; border-top: 1px solid rgba(0,0,0,0.22)">
              <p class="caption font-weight-medium grey--text text--darken-2 ma-0">ID</p>
              <p class="caption font-weight-medium grey--text text--darken-2 ma-0">Modelo</p>
              <p class="caption font-weight-medium grey--text text--darken-2 ma-0">De</p>
              <p class="caption font-weight-medium grey--text text--darken-2 ma-0">Até</p>
              <p class="caption font-weight-medium grey--text text--darken-2 ma-0">{{ labelBonus(meta) }}</p>
            </div>
            <div style="border-top: 1px solid rgba(0,0,0,0.22)">
              <div
                v-for="faixa in fatiar(metaInfo(meta.id_campanha_meta).faixasModelo, 'modelo', meta.id_campanha_meta)"
                :key="faixa._key"
                style="display: grid; grid-template-columns: 70px 1fr 90px 90px 130px; align-items: center; padding: 8px 12px; border-bottom: 1px solid rgba(0,0,0,0.18)"
              >
                <span class="caption font-weight-medium">{{ faixa.id_produto }}</span>
                <span class="caption grey--text text--darken-1">{{ faixa.produto || "—" }}</span>
                <span class="caption">{{ faixa.qtde_de }}</span>
                <span class="caption">{{ faixa.qtde_ate }}</span>
                <span class="caption font-weight-bold" style="color: #1976d2">{{ formatarMoeda(faixa.valor_bonus) }}</span>
              </div>
            </div>
          </template>
          <template v-else>
            <div style="display: grid; grid-template-columns: 70px 1fr; padding: 6px 12px; background: #eeeeee; border-top: 1px solid rgba(0,0,0,0.22)">
              <p class="caption font-weight-medium grey--text text--darken-2 ma-0">ID</p>
              <p class="caption font-weight-medium grey--text text--darken-2 ma-0">Modelo</p>
            </div>
            <div style="border-top: 1px solid rgba(0,0,0,0.22)">
              <div
                v-for="m in fatiar(metaInfo(meta.id_campanha_meta).modelos, 'modelo', meta.id_campanha_meta)"
                :key="m.id_produto"
                style="display: grid; grid-template-columns: 70px 1fr; align-items: center; padding: 8px 12px; border-bottom: 1px solid rgba(0,0,0,0.18)"
              >
                <span class="caption font-weight-medium">{{ m.id_produto }}</span>
                <span class="caption grey--text text--darken-1">{{ m.produto || "—" }}</span>
              </div>
            </div>
          </template>
        </div>
      </template>

      <!-- conteúdo: peças -->
      <template v-else-if="meta.id_tipo_conteudo == 4">
        <div style="border-top: 1px solid rgba(0,0,0,0.28)">
          <div style="padding: 8px 12px; background: #f5f5f5">
            <p class="caption font-weight-bold text-uppercase grey--text text--darken-2 ma-0" style="letter-spacing: 0.06em">
              Peças
              <span style="color: #1976d2">({{ meta.id_tipo_calculo == 2 ? metaInfo(meta.id_campanha_meta).faixasPeca.length : metaInfo(meta.id_campanha_meta).pecas.length }})</span>
            </p>
          </div>
          <template v-if="meta.id_tipo_calculo == 2">
            <div style="display: grid; grid-template-columns: 80px 1fr 90px 90px 130px; padding: 6px 12px; background: #eeeeee; border-top: 1px solid rgba(0,0,0,0.22)">
              <p class="caption font-weight-medium grey--text text--darken-2 ma-0">ID</p>
              <p class="caption font-weight-medium grey--text text--darken-2 ma-0">Peça</p>
              <p class="caption font-weight-medium grey--text text--darken-2 ma-0">De</p>
              <p class="caption font-weight-medium grey--text text--darken-2 ma-0">Até</p>
              <p class="caption font-weight-medium grey--text text--darken-2 ma-0">{{ labelBonus(meta) }}</p>
            </div>
            <div style="border-top: 1px solid rgba(0,0,0,0.22)">
              <div
                v-for="faixa in metaInfo(meta.id_campanha_meta).faixasPeca"
                :key="faixa._key"
                style="display: grid; grid-template-columns: 80px 1fr 90px 90px 130px; align-items: center; padding: 8px 12px; border-bottom: 1px solid rgba(0,0,0,0.18)"
              >
                <span class="caption font-weight-medium">{{ faixa.id_peca }}</span>
                <span class="caption grey--text text--darken-1">{{ faixa.peca_acessorio || "—" }}</span>
                <span class="caption">{{ faixa.qtde_de }}</span>
                <span class="caption">{{ faixa.qtde_ate }}</span>
                <span class="caption font-weight-bold" style="color: #1976d2">{{ formatarMoeda(faixa.valor_bonus) }}</span>
              </div>
            </div>
          </template>
          <template v-else>
            <div style="display: grid; grid-template-columns: 80px 1fr; padding: 6px 12px; background: #eeeeee; border-top: 1px solid rgba(0,0,0,0.22)">
              <p class="caption font-weight-medium grey--text text--darken-2 ma-0">ID</p>
              <p class="caption font-weight-medium grey--text text--darken-2 ma-0">Peça</p>
            </div>
            <div style="border-top: 1px solid rgba(0,0,0,0.22)">
              <div
                v-for="m in metaInfo(meta.id_campanha_meta).pecas"
                :key="m.id_peca"
                style="display: grid; grid-template-columns: 80px 1fr; align-items: center; padding: 8px 12px; border-bottom: 1px solid rgba(0,0,0,0.18)"
              >
                <span class="caption font-weight-medium">{{ m.id_peca }}</span>
                <span class="caption grey--text text--darken-1">{{ m.peca_acessorio || "—" }}</span>
              </div>
            </div>
          </template>
        </div>
      </template>

      <!-- conteúdo: serviços -->
      <template v-else-if="meta.id_tipo_conteudo == 5">
        <div style="border-top: 1px solid rgba(0,0,0,0.28)">
          <div style="padding: 8px 12px; background: #f5f5f5">
            <p class="caption font-weight-bold text-uppercase grey--text text--darken-2 ma-0" style="letter-spacing: 0.06em">
              Serviços
              <span style="color: #1976d2">({{ meta.id_tipo_calculo == 2 ? metaInfo(meta.id_campanha_meta).faixasServico.length : metaInfo(meta.id_campanha_meta).servicos.length }})</span>
            </p>
          </div>
          <template v-if="meta.id_tipo_calculo == 2">
            <div style="display: grid; grid-template-columns: 80px 1fr 90px 90px 130px; padding: 6px 12px; background: #eeeeee; border-top: 1px solid rgba(0,0,0,0.22)">
              <p class="caption font-weight-medium grey--text text--darken-2 ma-0">ID</p>
              <p class="caption font-weight-medium grey--text text--darken-2 ma-0">Serviço</p>
              <p class="caption font-weight-medium grey--text text--darken-2 ma-0">De</p>
              <p class="caption font-weight-medium grey--text text--darken-2 ma-0">Até</p>
              <p class="caption font-weight-medium grey--text text--darken-2 ma-0">{{ labelBonus(meta) }}</p>
            </div>
            <div style="border-top: 1px solid rgba(0,0,0,0.22)">
              <div
                v-for="faixa in metaInfo(meta.id_campanha_meta).faixasServico"
                :key="faixa._key"
                style="display: grid; grid-template-columns: 80px 1fr 90px 90px 130px; align-items: center; padding: 8px 12px; border-bottom: 1px solid rgba(0,0,0,0.18)"
              >
                <span class="caption font-weight-medium">{{ faixa.id_servico }}</span>
                <span class="caption grey--text text--darken-1">{{ faixa.servico || "—" }}</span>
                <span class="caption">{{ faixa.qtde_de }}</span>
                <span class="caption">{{ faixa.qtde_ate }}</span>
                <span class="caption font-weight-bold" style="color: #1976d2">{{ formatarMoeda(faixa.valor_bonus) }}</span>
              </div>
            </div>
          </template>
          <template v-else>
            <div style="display: grid; grid-template-columns: 80px 1fr; padding: 6px 12px; background: #eeeeee; border-top: 1px solid rgba(0,0,0,0.22)">
              <p class="caption font-weight-medium grey--text text--darken-2 ma-0">ID</p>
              <p class="caption font-weight-medium grey--text text--darken-2 ma-0">Serviço</p>
            </div>
            <div style="border-top: 1px solid rgba(0,0,0,0.22)">
              <div
                v-for="m in metaInfo(meta.id_campanha_meta).servicos"
                :key="m.id_servico"
                style="display: grid; grid-template-columns: 80px 1fr; align-items: center; padding: 8px 12px; border-bottom: 1px solid rgba(0,0,0,0.18)"
              >
                <span class="caption font-weight-medium">{{ m.id_servico }}</span>
                <span class="caption grey--text text--darken-1">{{ m.servico || "—" }}</span>
              </div>
            </div>
          </template>
        </div>
      </template>

      <!-- meta do participante: segunda meta, independente da meta por item.
           Some o realizado de todos os modelos e paga um bonus proprio.
           Mesma ordem da tela de cadastro: meta do item primeiro, depois esta. -->
      <template v-if="temMetaParticipante(meta)">
        <div style="border-top: 1px solid rgba(0,0,0,0.28)">
          <div style="padding: 8px 12px; background: #f5f5f5">
            <div style="display: flex; justify-content: space-between; align-items: center">
              <p class="caption font-weight-bold text-uppercase grey--text text--darken-2 ma-0" style="letter-spacing: 0.06em">
                Meta individual do participante
                <span style="color: #1976d2">({{ metaParticipanteLinhas(meta).length }})</span>
              </p>
              <PaginadorSecao
                rotulo="Participantes"
                :pagina="paginaDe('metaPart', meta.id_campanha_meta)"
                :total-paginas="totalPaginas(metaParticipanteLinhas(meta).length)"
                @mudar="d => mudarPagina('metaPart', meta.id_campanha_meta, d, metaParticipanteLinhas(meta).length)"
              />
            </div>
            <p class="caption grey--text text--darken-1 ma-0 mt-1" style="line-height: 1.4">
              Meta: <strong>{{ labelOrigemMetaParticipante(meta) }}</strong>
              <span class="mx-1" style="color: rgba(0,0,0,0.3)">·</span>
              Bônus: <strong>{{ labelBonusParticipante(meta) }}</strong>
            </p>
          </div>
          <div style="display: grid; grid-template-columns: 1.5fr 1fr 100px 80px 150px; padding: 6px 12px; background: #eeeeee; border-top: 1px solid rgba(0,0,0,0.22)">
            <p class="caption font-weight-medium grey--text text--darken-2 ma-0">Colaborador</p>
            <p class="caption font-weight-medium grey--text text--darken-2 ma-0">Empresa</p>
            <p class="caption font-weight-medium grey--text text--darken-2 ma-0 text-right">Média ref.</p>
            <p class="caption font-weight-medium grey--text text--darken-2 ma-0 text-right">Meta</p>
            <p class="caption font-weight-medium grey--text text--darken-2 ma-0 text-right">{{ rotuloBonusParticipante(meta) }}</p>
          </div>
          <div style="border-top: 1px solid rgba(0,0,0,0.22)">
            <div
              v-if="metaParticipanteLinhas(meta).length === 0"
              class="px-3 py-2"
            >
              <span class="caption grey--text">Nenhuma meta de participante gravada para esta meta.</span>
            </div>
            <div
              v-for="linha in fatiar(metaParticipanteLinhas(meta), 'metaPart', meta.id_campanha_meta)"
              :key="linha._key"
              style="display: grid; grid-template-columns: 1.5fr 1fr 100px 80px 150px; align-items: center; padding: 8px 12px; border-bottom: 1px solid rgba(0,0,0,0.18)"
            >
              <span class="caption font-weight-medium">{{ linha.nome }}</span>
              <span class="caption grey--text text--darken-1">{{ linha.nome_empresa || "—" }}</span>
              <span class="caption grey--text text--darken-1 text-right">{{ formatarMedia(linha.media) }}</span>
              <span class="caption font-weight-bold text-right">
                {{ linha.meta != null ? linha.meta : "—" }}
                <v-chip v-if="linha.manual" x-small color="blue lighten-4" class="ml-1 font-weight-bold">manual</v-chip>
              </span>
              <!-- Travessao, nao R$ 0,00: bonus nunca calculado (meta gravada
                   antes da coluna existir, ou salva sem a comissao ter sido
                   buscada) e diferente de bonus que deu zero. A primeira
                   apuracao preenche. -->
              <span v-if="linha.bonus == null" class="caption grey--text text-right">—</span>
              <span v-else class="caption font-weight-bold text-right" style="color: #1976d2">{{ formatarMoeda(linha.bonus) }}</span>
            </div>
            <!-- Subtotal da camada, para o valor nao ficar so linha a linha:
                 e o custo do bonus do participante se todos baterem a meta. -->
            <div
              v-if="metaParticipanteLinhas(meta).length"
              style="display: grid; grid-template-columns: 1.5fr 1fr 100px 80px 150px; align-items: center; padding: 6px 12px; background: rgba(0,0,0,0.02)"
            >
              <span class="caption grey--text text--darken-1" style="grid-column: 1 / 5">
                <!-- soma TODOS os participantes, nao so os da pagina -->
                Subtotal do bônus do participante (todos batendo a meta)
                <span v-if="algumBonusNaoCalculado(meta)" class="grey--text" style="font-size: 11px">
                  — parcial: há participante sem bônus calculado ainda
                </span>
              </span>
              <span class="caption font-weight-bold text-right primary--text">{{ formatarMoeda(totalBonusParticipante(meta)) }}</span>
            </div>
          </div>
        </div>
      </template>

      <!-- footer -->
      <div class="px-3 py-2" style="border-top: 1px solid rgba(0,0,0,0.25); background: rgba(0,0,0,0.02)">
        <!-- Resumo por indicador (Meta Fixa) -->
        <template v-if="meta.id_tipo_conteudo == 1 && meta.id_tipo_calculo != 2">
          <div class="mb-2" style="border-bottom: 1px solid rgba(0,0,0,0.1); padding-bottom: 6px">
            <p class="caption font-weight-bold text-uppercase grey--text text--darken-2 ma-0 mb-1" style="letter-spacing: 0.05em; font-size: 10px">Resumo por Indicador</p>
            <div
              v-for="ind in indicadoresResumo(meta)"
              :key="ind.id_indicador"
              style="display: flex; justify-content: space-between; align-items: baseline; padding: 2px 0; border-bottom: 1px dotted rgba(0,0,0,0.08)"
            >
              <span class="caption grey--text text--darken-2">
                <strong>{{ ind.id_indicador }}</strong> — {{ ind.indicador || '—' }}
              </span>
              <span class="caption" style="white-space: nowrap; margin-left: 8px">
                Meta: <strong>{{ ind.valor_meta_display }}</strong>
                <span class="mx-1" style="color: rgba(0,0,0,0.3)">·</span>
                {{ labelBonus(meta) }}: <strong class="primary--text">{{ ind.valor_bonus_display }}</strong>
              </span>
            </div>
          </div>
        </template>
        <div style="display: flex; justify-content: flex-end; align-items: center">
          <span class="caption grey--text text--darken-1">
            {{ meta.id_tipo_conteudo == 2 ? 'Total estimado (simulação de todos os chassis):' : 'Total estimado (soma dos colaboradores):' }}
            <span class="font-weight-bold primary--text">{{ formatarMoeda(totalEstimadoMeta(meta)) }}</span>
          </span>
        </div>
        <!-- O total acima e a soma dos bonus por item. O bonus do participante
             fica de fora de proposito: na origem "% sobre referencia" ele
             depende da comissao P2 do mes, que esta listagem nao busca — somar
             so a origem "Informado" daria um total que muda de significado
             conforme a meta, pior do que a linha separada. -->
        <div v-if="temMetaParticipante(meta)" style="display: flex; justify-content: flex-end; align-items: center">
          <span class="caption grey--text" style="font-size: 11px">
            Não inclui o bônus da meta do participante ({{ labelBonusParticipante(meta) }}).
          </span>
        </div>
      </div>
      </template>
    </div>
  </div>
  </div>
</template>

<script>
import { formatarCompetencia } from "./calculo/bonusReferenciaUtils";
import PaginadorSecao from "./PaginadorSecao";
import multiplicadorBonus from "@/utils/multiplicadorBonus";

// Competencia do fechamento da campanha, vinda da propria linha da meta:
// vw_mcp_campanha_meta ja expoe mes_ref/ano_ref pelo join com
// mcw_tipo_fechamento. Antes a listagem descobria isso com uma requisicao a
// comissao/tipo-fechamento so para escrever o mes no rotulo; agora vem de
// carona com as metas.
function competenciaDaMeta(meta) {
  if (meta.mes_ref == null || meta.ano_ref == null) return null;
  return { mes_ref: meta.mes_ref, ano_ref: meta.ano_ref };
}

export default {
  name: "ListaCardMetas",

  components: { PaginadorSecao },

  props: {
    metas: { type: Array, default: () => [] },
    campanha: { type: Object, default: () => ({}) },
    arrayFechamentosSemanal: { type: Array, default: () => [] },
    // Mapa { id_campanha_meta: [{ id_colaborador, id_empresa, valor_meta,
    // valor_media_referencia, meta_manual }] } — irmao de `data` na resposta
    // de metas-campanha, ver SectionPublicoMeta.carregarMetasCadastradas.
    // Vem separado das linhas porque a meta do participante e uma por
    // participante, nao uma por linha (colaborador x modelo).
    metasColaborador: { type: Object, default: () => ({}) },
    onEdite: { type: Boolean, default: true }
  },

  data() {
    return {
      abertos: {}, // { [id_campanha_meta]: boolean } — card expandido?
      // Página atual de cada seção paginada, por meta:
      // { "part:55": 2, "modelo:55": 1, "metaPart:55": 3 }
      // Uma chave só em vez de um objeto por seção — as três paginam igual.
      paginas: {},
      POR_PAGINA: 10,
      LIMITE_METAS_AUTO: 3, // acima disso, começa tudo recolhido
      LIMITE_PART_AUTO: 10 // meta com mais participantes que isso começa recolhida
    };
  },

  watch: {
    // (Re)inicializa o estado de aberto/recolhido quando as metas mudam,
    // preservando as escolhas manuais já feitas pelo usuário.
    todasMetas: {
      immediate: true,
      handler() {
        this.initEstadoAbertos();
      }
    }
  },

  computed: {
    algumFechado() {
      return this.todasMetas.some(m => !this.isAberto(m.id_campanha_meta));
    },

    todasMetas() {
      const seen = new Set();
      return this.metas
        .filter(m => {
          if (seen.has(m.id_campanha_meta)) return false;
          seen.add(m.id_campanha_meta);
          return true;
        })
        .sort((a, b) =>
          Number(a.id_tipo_conteudo) - Number(b.id_tipo_conteudo) ||
          Number(a.id_campanha_meta) - Number(b.id_campanha_meta)
        );
    },

    metaInfoMap() {
      const map = {};
      for (const row of this.metas) {
        const id = row.id_campanha_meta;
        if (!id) continue;
        if (!map[id]) {
          map[id] = {
            colaboradores: [],
            equipes: [],
            empresas: [],
            indicadoresRaw: [],
            faixasIndicador: [],
            chassi: [],
            chassiRaw: [],
            modelos: [],
            modelosRaw: [],
            faixasModelo: [],
            pecas: [],
            pecasRaw: [],
            faixasPeca: [],
            servicos: [],
            servicosRaw: [],
            faixasServico: []
          };
        }
        const m = map[id];

        if (row.colaborador) {
          // Por (colaborador, EMPRESA): e assim que a meta grava, e a propria
          // linha da tabela ja usa nome+empresa como :key. Deduplicar so pelo
          // nome escondia o segundo vinculo da mesma pessoa e fazia a contagem
          // de participantes divergir do que esta gravado.
          if (!m.colaboradores.some(c => c.nome === row.colaborador
                                      && c.id_empresa == row.id_empresa)) {
            m.colaboradores.push({
              id_colaborador: row.id_colaborador || null,
              nome: row.colaborador,
              funcao: row.funcao,
              id_empresa: row.id_empresa,
              nome_empresa: row.nome_empresa,
              nome_equipe: row.nome_equipe || null
            });
          }
        }
        if (row.id_equipe) {
          if (!m.equipes.some(e => e.id_equipe == row.id_equipe))
            m.equipes.push({ id_equipe: row.id_equipe, nome_equipe: row.nome_equipe || null });
        }
        if (row.id_empresa && row.nome_empresa) {
          if (!m.empresas.some(e => e.id_empresa == row.id_empresa))
            m.empresas.push({ id_empresa: row.id_empresa, nome_empresa: row.nome_empresa });
        }

        // Indicadores raw (por colaborador × indicador)
        if (row.id_tipo_conteudo == 1 && row.id_tipo_calculo != 2 && row.id_indicador && row.colaborador) {
          const rk = `${row.colaborador}-${row.id_indicador}`;
          if (!m.indicadoresRaw.some(r => r._key === rk))
            m.indicadoresRaw.push({ _key: rk, colaborador: row.colaborador, id_indicador: row.id_indicador, indicador: row.indicador || null, valor_meta: row.valor_meta, valor_bonus: row.valor_bonus , base_calculo_indicador: row.base_calculo_indicador || null, tipo_apuracao: row.tipo_apuracao || null });
        }
        if (row.id_tipo_conteudo == 1 && row.id_tipo_calculo == 2 && row.id_indicador && row.qtde_de != null) {
          const key = `${row.id_indicador}-${row.qtde_de}-${row.qtde_ate}`;
          if (!m.faixasIndicador.some(f => f._key === key))
            m.faixasIndicador.push({ _key: key, id_indicador: row.id_indicador, indicador: row.indicador || null, qtde_de: row.qtde_de, qtde_ate: row.qtde_ate, valor_bonus: row.valor_bonus , base_calculo_indicador: row.base_calculo_indicador || null, tipo_apuracao: row.tipo_apuracao || null });
        }

        // Chassi raw (por colaborador × chassi)
        if (row.id_tipo_conteudo == 2 && row.chassi_completo) {
          if (!m.chassi.some(c => c.chassi_completo === row.chassi_completo))
            m.chassi.push({ chassi_completo: row.chassi_completo, chassi_resumido: row.chassi_resumido });
          if (row.colaborador) {
            const rk = `${row.colaborador}-${row.chassi_completo}`;
            if (!m.chassiRaw.some(r => r._key === rk))
              m.chassiRaw.push({ _key: rk, colaborador: row.colaborador, chassi_completo: row.chassi_completo, valor_bonus: row.valor_bonus });
          }
        }

        // Modelos raw (por colaborador × produto)
        if (row.id_tipo_conteudo == 3 && row.id_tipo_calculo != 2 && row.id_produto) {
          if (!m.modelos.some(p => p.id_produto == row.id_produto))
            m.modelos.push({ id_produto: row.id_produto, produto: row.produto || null });
          if (row.colaborador) {
            const rk = `${row.colaborador}-${row.id_produto}`;
            if (!m.modelosRaw.some(r => r._key === rk))
              m.modelosRaw.push({ _key: rk, colaborador: row.colaborador, id_produto: row.id_produto, valor_meta: row.valor_meta, valor_bonus: row.valor_bonus });
          }
        }
        if (row.id_tipo_conteudo == 3 && row.id_tipo_calculo == 2 && row.id_produto && row.qtde_de != null) {
          const key = `${row.id_produto}-${row.qtde_de}-${row.qtde_ate}`;
          if (!m.faixasModelo.some(f => f._key === key))
            m.faixasModelo.push({ _key: key, id_produto: row.id_produto, produto: row.produto || null, qtde_de: row.qtde_de, qtde_ate: row.qtde_ate, valor_bonus: row.valor_bonus });
        }

        // Peças raw (por colaborador × peça)
        if (row.id_tipo_conteudo == 4 && row.id_tipo_calculo != 2 && row.id_peca) {
          if (!m.pecas.some(p => p.id_peca == row.id_peca))
            m.pecas.push({ id_peca: row.id_peca, peca_acessorio: row.peca_acessorio || null });
          if (row.colaborador) {
            const rk = `${row.colaborador}-${row.id_peca}`;
            if (!m.pecasRaw.some(r => r._key === rk))
              m.pecasRaw.push({ _key: rk, colaborador: row.colaborador, id_peca: row.id_peca, valor_meta: row.valor_meta, valor_bonus: row.valor_bonus });
          }
        }
        if (row.id_tipo_conteudo == 4 && row.id_tipo_calculo == 2 && row.id_peca && row.qtde_de != null) {
          const key = `${row.id_peca}-${row.qtde_de}-${row.qtde_ate}`;
          if (!m.faixasPeca.some(f => f._key === key))
            m.faixasPeca.push({ _key: key, id_peca: row.id_peca, peca_acessorio: row.peca_acessorio || null, qtde_de: row.qtde_de, qtde_ate: row.qtde_ate, valor_bonus: row.valor_bonus });
        }

        // Serviços raw (por colaborador × serviço)
        if (row.id_tipo_conteudo == 5 && row.id_tipo_calculo != 2 && row.id_servico) {
          if (!m.servicos.some(p => p.id_servico == row.id_servico))
            m.servicos.push({ id_servico: row.id_servico, servico: row.servico || null });
          if (row.colaborador) {
            const rk = `${row.colaborador}-${row.id_servico}`;
            if (!m.servicosRaw.some(r => r._key === rk))
              m.servicosRaw.push({ _key: rk, colaborador: row.colaborador, id_servico: row.id_servico, valor_meta: row.valor_meta, valor_bonus: row.valor_bonus });
          }
        }
        if (row.id_tipo_conteudo == 5 && row.id_tipo_calculo == 2 && row.id_servico && row.qtde_de != null) {
          const key = `${row.id_servico}-${row.qtde_de}-${row.qtde_ate}`;
          if (!m.faixasServico.some(f => f._key === key))
            m.faixasServico.push({ _key: key, id_servico: row.id_servico, servico: row.servico || null, qtde_de: row.qtde_de, qtde_ate: row.qtde_ate, valor_bonus: row.valor_bonus });
        }
      }
      return map;
    }
  },

  methods: {
    // ----- recolher / expandir -----
    isAberto(id) {
      return !!this.abertos[id];
    },
    toggle(id) {
      this.$set(this.abertos, id, !this.abertos[id]);
    },
    toggleTodos() {
      // Se houver algum recolhido, expande todos; caso contrário, recolhe todos.
      const abrir = this.algumFechado;
      this.todasMetas.forEach(m =>
        this.$set(this.abertos, m.id_campanha_meta, abrir)
      );
    },
    initEstadoAbertos() {
      const muitasMetas = this.todasMetas.length > this.LIMITE_METAS_AUTO;
      this.todasMetas.forEach(m => {
        const id = m.id_campanha_meta;
        if (this.abertos[id] !== undefined) return; // preserva escolha do usuário
        const nPart = this.metaInfo(id).colaboradores.length;
        const recolher = muitasMetas || nPart > this.LIMITE_PART_AUTO;
        this.$set(this.abertos, id, !recolher);
      });
    },

    // ----- paginação das seções (participantes, modelos, metas do participante) -----
    paginaDe(secao, id) {
      return this.paginas[`${secao}:${id}`] || 1;
    },

    totalPaginas(quantidade) {
      return Math.max(1, Math.ceil((quantidade || 0) / this.POR_PAGINA));
    },

    mudarPagina(secao, id, delta, quantidade) {
      const nova = Math.min(
        this.totalPaginas(quantidade),
        Math.max(1, this.paginaDe(secao, id) + delta)
      );
      this.$set(this.paginas, `${secao}:${id}`, nova);
    },

    // Fatia a lista na página atual. Recorta contra o total real em vez de
    // confiar na página guardada: editar a meta pode encurtar a lista, e a
    // página que sobrou apontaria para o vazio.
    fatiar(lista, secao, id) {
      const todos = lista || [];
      const pagina = Math.min(this.paginaDe(secao, id), this.totalPaginas(todos.length));
      const ini = (pagina - 1) * this.POR_PAGINA;
      return todos.slice(ini, ini + this.POR_PAGINA);
    },

    // Faixa progressiva lista faixas; meta fixa lista modelos. A paginação da
    // seção "Modelos" precisa contar a que esta sendo exibida.
    listaModelos(meta) {
      const info = this.metaInfo(meta.id_campanha_meta);
      return Number(meta.id_tipo_calculo) === 2 ? info.faixasModelo : info.modelos;
    },

    metaInfo(id) {
      return this.metaInfoMap[id] || {
        colaboradores: [], equipes: [], empresas: [],
        indicadoresRaw: [], faixasIndicador: [],
        chassi: [], chassiRaw: [],
        modelos: [], modelosRaw: [], faixasModelo: [],
        pecas: [], pecasRaw: [], faixasPeca: [],
        servicos: [], servicosRaw: [], faixasServico: []
      };
    },

    // Grid CSS da linha de colaboradores: varia conforme tipo de conteúdo e cálculo
    gridColaboradores(meta) {
      const isProgressivo = meta.id_tipo_calculo == 2;
      const isChassi = meta.id_tipo_conteudo == 2;
      const isIndicador = meta.id_tipo_conteudo == 1 && meta.id_tipo_calculo != 2;
      // Nome | Função | Empresa | [Meta] | Bônus | [Bônus Estimado]
      if (isProgressivo) return { display: 'grid', gridTemplateColumns: '1.5fr 1fr 1fr 110px' };
      if (isChassi)      return { display: 'grid', gridTemplateColumns: '1.5fr 1fr 1fr 130px' };
      if (isIndicador)   return { display: 'grid', gridTemplateColumns: '1.5fr 1fr 1fr 90px 130px 130px' };
      return { display: 'grid', gridTemplateColumns: '1.5fr 1fr 1fr 90px 130px' };
    },

    // Valor da meta do colaborador para exibição na tabela de participantes
    getColabMeta(metaId, nomeColaborador, meta) {
      const info = this.metaInfo(metaId);
      const tc = Number(meta.id_tipo_conteudo);
      const rawMap = { 1: info.indicadoresRaw, 3: info.modelosRaw, 4: info.pecasRaw, 5: info.servicosRaw };
      const rows = (rawMap[tc] || []).filter(r => r.colaborador === nomeColaborador);
      if (rows.length === 0) return '—';
      const metas = [...new Set(rows.map(r => r.valor_meta).filter(v => v != null))];
      if (metas.length === 1) return metas[0];
      return metas.join(' / ');
    },

    // Valor do bônus do colaborador para exibição na tabela de participantes
    getColabBonus(metaId, nomeColaborador, meta) {
      const info = this.metaInfo(metaId);
      const tc = Number(meta.id_tipo_conteudo);

      if (tc === 1) {
        // Indicadores: valor_bonus é compartilhado — mostra o bônus da meta
        return this.formatarMoeda(meta.valor_bonus);
      }
      if (tc === 2) {
        const rows = info.chassiRaw.filter(r => r.colaborador === nomeColaborador);
        const total = rows.reduce((s, r) => s + (parseFloat(r.valor_bonus) || 0), 0);
        return this.formatarMoeda(total);
      }
      const rawMap = { 3: info.modelosRaw, 4: info.pecasRaw, 5: info.servicosRaw };
      const rows = (rawMap[tc] || []).filter(r => r.colaborador === nomeColaborador);
      if (rows.length === 0) return '—';
      // Para múltiplos itens: mostra lista de bônus distintos ou bônus único
      const bonuses = [...new Set(rows.map(r => r.valor_bonus).filter(v => v != null))];
      if (bonuses.length === 1) return this.formatarMoeda(bonuses[0]);
      return bonuses.map(b => this.formatarMoeda(b)).join(' / ');
    },

    indicadoresResumo(meta) {
      const info = this.metaInfo(meta.id_campanha_meta);
      const tipoPagamento = Number(meta.id_tipo_pagamento);
      const seen = new Map();
      for (const row of info.indicadoresRaw) {
        if (!seen.has(row.id_indicador)) {
          seen.set(row.id_indicador, { id_indicador: row.id_indicador, indicador: row.indicador, rows: [] });
        }
        seen.get(row.id_indicador).rows.push(row);
      }
      const isIndividual = Number(meta.id_tipo_realizado) === 1;
      return [...seen.values()].map(e => {
        const sumMeta = e.rows.reduce((s, r) => s + (parseFloat(r.valor_meta) || 0), 0);
        // Individual: soma as metas (total esperado, cada colaborador tem a sua).
        // Empresa/Equipe: a meta é a mesma para todos, então mostra a média
        // (que normalmente equivale ao valor de cada colaborador).
        const metaDisplay = isIndividual
          ? sumMeta
          : e.rows.length
            ? Math.round((sumMeta / e.rows.length) * 100) / 100
            : 0;
        const sumBonus = tipoPagamento === 1
          ? e.rows.reduce((s, r) => s + (parseFloat(r.valor_meta) || 0) * (parseFloat(r.valor_bonus) || 0), 0)
          : e.rows.reduce((s, r) => s + (parseFloat(r.valor_bonus) || 0), 0);
        return {
          id_indicador: e.id_indicador,
          indicador: e.indicador,
          valor_meta_display: metaDisplay,
          valor_bonus_display: this.formatarMoeda(sumBonus)
        };
      });
    },

    // Total estimado somando todos os colaboradores a partir dos arrays raw
    totalEstimadoMeta(meta) {
      const info = this.metaInfo(meta.id_campanha_meta);
      const tc = Number(meta.id_tipo_conteudo);
      const tipoPagamento = Number(meta.id_tipo_pagamento);
      const tipoCalculo = Number(meta.id_tipo_calculo);
      const nSemanas = this.campanha.id_tipo_dado === 'C' && this.arrayFechamentosSemanal.length > 0
        ? this.arrayFechamentosSemanal.length : 1;

      if (tipoCalculo === 2) {
        // Faixa progressiva: estima pela última faixa
        const faixasMap = {
          1: { faixas: info.faixasIndicador, idKey: 'id_indicador' },
          3: { faixas: info.faixasModelo,    idKey: 'id_produto' },
          4: { faixas: info.faixasPeca,      idKey: 'id_peca' },
          5: { faixas: info.faixasServico,   idKey: 'id_servico' }
        }[tc];
        if (!faixasMap) return 0;
        const ids = [...new Set(faixasMap.faixas.map(f => f[faixasMap.idKey]))];
        const nCollabs = info.colaboradores.length || 1;
        let porCollab = 0;
        ids.forEach(id => {
          const faixas = faixasMap.faixas
            .filter(f => f[faixasMap.idKey] == id)
            .sort((a, b) => parseFloat(b.qtde_ate) - parseFloat(a.qtde_ate));
          if (faixas.length > 0)
            porCollab +=
              multiplicadorBonus({
                tipoPagamento,
                tipoApuracao: faixas[0].tipo_apuracao,
                baseCalculo: faixas[0].base_calculo_indicador,
                quantidade: faixas[0].qtde_ate
              }) * (parseFloat(faixas[0].valor_bonus) || 0);
        });
        return porCollab * nCollabs * (tc === 1 ? nSemanas : 1);
      }

      if (tc === 1) {
        // Indicadores: bônus compartilhado; soma valor_meta por colaborador
        const bonus = parseFloat(meta.valor_bonus) || 0;
        const nCollabs = info.colaboradores.length || 1;
        if (tipoPagamento === 2) return bonus * nCollabs * nSemanas;
        // Por unidade: calcula com base nos raw por colaborador. O multiplicador
        // e por INDICADOR - margem 'P' entra com zero, quantidade com a meta.
        const colabs = [...new Set(info.indicadoresRaw.map(r => r.colaborador))];
        let total = 0;
        colabs.forEach(colab => {
          const rows = info.indicadoresRaw.filter(r => r.colaborador === colab);
          const sumMeta = rows.reduce(
            (s, r) =>
              s +
              multiplicadorBonus({
                tipoPagamento,
                tipoApuracao: r.tipo_apuracao,
                baseCalculo: r.base_calculo_indicador,
                quantidade: r.valor_meta
              }),
            0
          );
          total += sumMeta * bonus;
        });
        return total * nSemanas;
      }

      if (tc === 2) {
        // Chassi: cada chassi é único — soma bônus por chassi distinto (igual ao que cada colaborador pode ganhar)
        const seen = new Set();
        let total = 0;
        for (const r of info.chassiRaw) {
          if (seen.has(r.chassi_completo)) continue;
          seen.add(r.chassi_completo);
          total += parseFloat(r.valor_bonus) || 0;
        }
        return total;
      }

      // Modelos, Peças, Serviços: soma por colaborador × item
      const rawMap = { 3: info.modelosRaw, 4: info.pecasRaw, 5: info.servicosRaw };
      const rows = rawMap[tc] || [];
      return rows.reduce((s, r) => {
        const bonus = parseFloat(r.valor_bonus) || 0;
        return (
          s +
          multiplicadorBonus({ tipoPagamento, quantidade: r.valor_meta }) * bonus
        );
      }, 0);
    },

    getColabBonusEstimado(metaId, nomeColaborador, meta) {
      const info = this.metaInfo(metaId);
      const tipoPagamento = Number(meta.id_tipo_pagamento);
      const rows = info.indicadoresRaw.filter(r => r.colaborador === nomeColaborador);
      if (rows.length === 0) return '—';
      if (tipoPagamento === 1) {
        const total = rows.reduce((s, r) => s + (parseFloat(r.valor_meta) || 0) * (parseFloat(r.valor_bonus) || 0), 0);
        return this.formatarMoeda(total);
      }
      const total = rows.reduce((s, r) => s + (parseFloat(r.valor_bonus) || 0), 0);
      return this.formatarMoeda(total);
    },

    custoEstimadoCardData(meta) {
      const info = this.metaInfo(meta.id_campanha_meta);
      const tipoPagamento = Number(meta.id_tipo_pagamento);
      const linhas = [];

      // Agrupa por indicador
      const indicadoresMap = new Map();
      for (const row of info.indicadoresRaw) {
        if (!indicadoresMap.has(row.id_indicador)) {
          indicadoresMap.set(row.id_indicador, { id: row.id_indicador, nome: row.indicador, rows: [] });
        }
        indicadoresMap.get(row.id_indicador).rows.push(row);
      }

      // Calcula por indicador
      let porColaborador = 0;
      for (const ind of indicadoresMap.values()) {
        const sumMeta = ind.rows.reduce((s, r) => s + (parseFloat(r.valor_meta) || 0), 0);
        const sumBonus = tipoPagamento === 1
          ? ind.rows.reduce((s, r) => s + (parseFloat(r.valor_meta) || 0) * (parseFloat(r.valor_bonus) || 0), 0)
          : ind.rows.reduce((s, r) => s + (parseFloat(r.valor_bonus) || 0), 0);

        if (tipoPagamento === 1) {
          linhas.push({
            label: `${ind.id} — ${ind.nome}`,
            detalhe: `— ${sumMeta} un × ${this.formatarMoeda(ind.rows[0]?.valor_bonus || 0)}/un`,
            valor: sumBonus
          });
        } else {
          linhas.push({
            label: `${ind.id} — ${ind.nome}`,
            detalhe: `— Bônus fixo`,
            valor: sumBonus
          });
        }
        porColaborador += sumBonus / (info.colaboradores.length || 1);
      }

      return {
        porColaborador: porColaborador || 0,
        total: this.totalEstimadoMeta(meta),
        nSemanas: 1,
        linhas
      };
    },

    // A camada do participante e opcional e vem por meta (nao por linha):
    // usa_meta_colaborador 'S'/'N' em vw_mcp_campanha_meta. Meta antiga,
    // gravada antes da coluna existir, vem null e cai no false.
    temMetaParticipante(meta) {
      return String(meta.usa_meta_colaborador || "").toUpperCase() === "S";
    },

    // Uma linha por participante com meta individual gravada, lida de
    // metasColaborador (que a API devolve ja deduplicada, uma entrada por
    // colaborador) e cruzada com metaInfo so para pegar nome e empresa —
    // que moram nas linhas do historico, nao na tabela da meta do participante.
    metaParticipanteLinhas(meta) {
      if (!this.temMetaParticipante(meta)) return [];
      const entradas = (this.metasColaborador || {})[meta.id_campanha_meta] || [];
      const porId = {};
      this.metaInfo(meta.id_campanha_meta).colaboradores.forEach(c => {
        if (c.id_colaborador != null) porId[String(c.id_colaborador)] = c;
      });
      return entradas.map(e => {
        const col = porId[String(e.id_colaborador)] || {};
        return {
          _key: `${e.id_colaborador}-${e.id_empresa}`,
          nome: col.nome || `#${e.id_colaborador}`,
          nome_empresa: col.nome_empresa || null,
          // null preservado: origem Informada nao tem media por definicao, e
          // colaborador sem historico tambem cai em null — zero ali seria
          // indistinguivel de uma media que realmente deu zero. Mesmo cuidado
          // de metaColaboradorLeituraUtils.montarMetasCalculadas.
          media: e.valor_media_referencia != null ? Number(e.valor_media_referencia) : null,
          meta: e.valor_meta != null ? Number(e.valor_meta) : null,
          manual: String(e.meta_manual || "").toUpperCase() === "S",
          bonus: this.bonusParticipante(meta, e)
        };
      });
    },

    // Bonus da camada do participante para um colaborador.
    //
    // Origem 2 (% sobre referencia): LE o valor gravado (Fase 5), nao recalcula
    // nem busca comissao. E cache: gravado no cadastro e reescrito a cada
    // apuracao com a comissao do momento. null = nunca calculado (meta gravada
    // antes da coluna existir, ou salva sem a comissao ter sido buscada) — a
    // primeira apuracao preenche.
    //
    // Origem 1 (Informado): o valor fixo da propria meta, igual para todos.
    bonusParticipante(meta, entrada) {
      if (Number(meta.id_origem_bonus) === 2) {
        return entrada.valor_bonus != null ? Number(entrada.valor_bonus) : null;
      }
      return parseFloat(meta.valor_bonus_colaborador) || 0;
    },

    // Ignora as linhas sem valor calculado em vez de contar como zero: um
    // subtotal que soma "desconhecido" como 0 parece um custo menor do que e.
    totalBonusParticipante(meta) {
      return this.metaParticipanteLinhas(meta)
        .reduce((s, l) => s + (l.bonus != null ? l.bonus : 0), 0);
    },

    algumBonusNaoCalculado(meta) {
      return this.metaParticipanteLinhas(meta).some(l => l.bonus == null);
    },

    // A competencia no rotulo evita que a coluna seja lida como "o bonus que
    // vai receber": e o valor da comissao P2 daquele mes na ultima vez que foi
    // calculado, e a comissao ainda cresce ate o mes fechar.
    rotuloBonusParticipante(meta) {
      if (Number(meta.id_origem_bonus) !== 2) return "Bônus";
      const competencia = formatarCompetencia(competenciaDaMeta(meta));
      return competencia ? `Bônus ref. (${competencia})` : "Bônus ref.";
    },

    labelOrigemMetaParticipante(meta) {
      if (meta.origem_meta) return meta.origem_meta;
      return Number(meta.id_origem_meta) === 2 ? "Média histórica" : "Informada";
    },

    labelBonusParticipante(meta) {
      if (Number(meta.id_origem_bonus) === 2) {
        const p = parseFloat(meta.percentual_bonus_colaborador) || 0;
        return `${p.toLocaleString("pt-BR")}% sobre a comissão de referência`;
      }
      return this.formatarMoeda(meta.valor_bonus_colaborador);
    },

    formatarMedia(n) {
      if (n == null) return "—";
      return Number(n).toLocaleString("pt-BR", { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    },

    labelIndicadores(metaId) {
      const seen = new Set();
      const names = [];
      for (const r of this.metas) {
        if (r.id_campanha_meta != metaId || !r.id_indicador) continue;
        if (seen.has(r.id_indicador)) continue;
        seen.add(r.id_indicador);
        names.push(r.indicador);
      }
      return names.join(', ');
    },

    labelRealizado(meta) {
      return meta.tipo_realizado || { 1: 'Individual', 2: 'Equipe', 3: 'Empresa' }[meta.id_tipo_realizado] || '—';
    },

    labelCalculo(meta) {
      return meta.id_tipo_calculo == 2 ? 'Faixa Progressiva' : 'Meta Fixa';
    },

    labelPagamento(meta) {
      return meta.tipo_pagamento || { 1: 'Por Unidade', 2: 'Valor Fixo' }[meta.id_tipo_pagamento] || '—';
    },

    labelBonus(meta) {
      const tp = Number(meta.id_tipo_pagamento);
      if (tp === 1) return 'Bônus por unidade';
      if (tp === 2) return 'Bônus Fixo';
      return 'Bônus';
    },

    formatarMoeda(value) {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(parseFloat(value) || 0);
    }
  }
};
</script>

<style scoped>
.meta-card .caption {
  font-size: 13px;
}
</style>
